// editor
import "react-quill/dist/quill.snow.css";

// scroll bar
import "simplebar-react/dist/simplebar.min.css";

// lightbox
import "react-image-lightbox/style.css";

// react
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { HelmetProvider } from "react-helmet-async";

// contexts
import { SettingsProvider } from "./contexts/SettingsContext";
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext";

//
import App from "./App";
import { store } from "@admin/redux";
import { Provider } from "react-redux";

const root = createRoot(document.getElementById("app")!);

root.render(
  <HelmetProvider>
    <SettingsProvider>
      <CollapseDrawerProvider>
        <Provider store={store}>
          <BrowserRouter
            future={{
              v7_startTransition: true,
              v7_relativeSplatPath: true,
            }}
          >
            <App />
          </BrowserRouter>
        </Provider>
      </CollapseDrawerProvider>
    </SettingsProvider>
  </HelmetProvider>
);
